import React, { useRef } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'
import { Flame } from './flame';

export function Miura(props) {
  const { nodes, materials } = useGLTF('/models/Miura5_Stage2.glb')
  const { firing, ...rest } = props;
  const meshRef = useRef();

  const AO = useTexture('./textures/Miura5_AO.webp')
  AO.flipY = false

  if(materials.M_Miura5) {
    materials.M_Miura5.aoMap = AO
    materials.M_Miura5.aoMapIntensity = 1
  }

  return (
    <group {...rest} dispose={null}>
      <group name="Scene">
        <group name="Thruster001" position={[0, -0.06, 0]}>
          {/* Only show flame when firing is true */}
          {firing && (
            <Flame color={'#ffcc7e'} rotation={[0, 0, Math.PI * 1]} scale={[0.015, 0.015, 0.015]} position={[0, 0, 0]} seed={1701} emissiveIntensity={20}/>
          )}
        </group>
        <mesh
          ref={meshRef}
          name="Miura5_St2"
          castShadow
          receiveShadow
          geometry={nodes.Miura5_St2.geometry}
          material={materials.M_Miura5}
        >
        </mesh>
      </group>
    </group>
  )
}

useGLTF.preload('/models/Miura5_Stage2.glb')


